module.exports = "/assets/8c98adf59d49dbdd1b4e8793027845ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/AR.png
// module id = 1205
// module chunks = 0